export enum DynamicMetadataType {
  Component = 'DynamicComponent',
  Property = 'DynamicProperty',
  Properties = 'DynamicProperties',
}
